import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Widget } from "react-typeform-embed";
import Header from "../components/header/clientHeader";
import Box from "@mui/material/Box";
import Login from "../components/loginModal/LoginModal";
import Snackbar from "@mui/material/Snackbar";
import "react-loading-skeleton/dist/skeleton.css";
import { Oval } from "react-loader-spinner";

function Client() {
  const navigate = useNavigate();

  const [showNotification, setShowNotification] = useState(false);

  const [displayMessage, setDisplayMessage] = useState("");

  const [justView, setJustView] = useState(true);
  const [showLoader, setShowLoader] = useState(true);
  useEffect(() => {
    document.title = "Sign Up";
    setTimeout(() => {
      setShowLoader(false);
    }, 3000);
  }, []);
  
  return (
    <div className="w-full h-screen">
      <Header justView={!justView} >       
        {showLoader && (
          <div className="fixed flex items-center justify-center z-10 w-full h-full top-0 bg-white-1">
            {/* Add backdrop */}
            
            <div className={`relative flex`}>
              <Oval
                  color="white"
                  secondaryColor="grey"
                  height="40"
                  width="60"
                />
                <div className="flex items-center">Hold Tight-just getting this page ready.</div>
            </div>
          </div>
        )}

        {/* Notification */}
        <Snackbar
          open={showNotification}
          message={displayMessage}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        />

        {/* Add div */}
        <div className="bg-grey-3 col-span-12 grid grid-cols-12 gap-0 h-screen">
          {/* Show typeform signup page */}
          <div className="col-span-6 h-screen">
            <div className="w-full h-screen flex justify-center items-center ">
              <Widget
                id="Ij9uC4kD"
                style={{
                  width: "80%",
                  height: "75vh",
                }}
                className="my-form"
              />
            </div>
          </div>

          {/* Show text */}

          <div className="col-span-6 bg-blue-7 h-screen relative">
            <div className="flex flex-col items-center justify-center h-screen">
              <div className="absolute -left-8 mb-36">
                <img src="/arrow.png" />
              </div>
              {/* Show arrow */}
              <div className="text-lg font-normal 2xl:text-3xl">
                Software engineers
                <div className="text-5xl font-bold mt-4 2xl:text-8xl">
                  Request for a
                  <br />
                  new account
                  <br />
                </div>
                <span className="text-pink-1 text-lg flex mt-4 2xl:text-4xl">
                  Our team will approve your request with in <br />
                  next 24 hours.
                </span>
              </div>
            </div>
          </div>
        </div>
      </Header>
    </div>
  );
}
export default Client;
